import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { slideInHorizontalAnimation } from '@freelancer/animations';
import { CalloutColor, CalloutPlacement } from '@freelancer/ui/callout';
import { IconColor } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-navigation-logged-out-home-section-hire-freelancers-by-skills',
  template: `
    <div
      [flMarginRightDesktopXLarge]="'large'"
      [flMarginBottom]="'mid'"
      [flMarginBottomDesktopXLarge]="'none'"
    >
      <fl-grid class="ThreeColumns">
        <fl-col
          [col]="6"
          [colTablet]="4"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'mid'"
        >
          <app-navigation-menu-card
            i18n-description="Graphic designers description"
            description="Graphic designers"
            [url]="'/hire/graphic-design'"
            [imgSrc]="'logged-out-navigation/hire-skills/graphic-design.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [colTablet]="4"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'mid'"
        >
          <app-navigation-menu-card
            i18n-description="Website designers description"
            description="Website designers"
            [url]="'/hire/website-design'"
            [imgSrc]="'logged-out-navigation/hire-skills/website.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [colTablet]="4"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'mid'"
        >
          <app-navigation-menu-card
            i18n-description="Mobile app developers description"
            description="Mobile app developers"
            [url]="'/hire/mobile-development'"
            [imgSrc]="'logged-out-navigation/hire-skills/mobile.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [colTablet]="4"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'none'"
        >
          <app-navigation-menu-card
            i18n-description="Software developers description"
            description="Software developers"
            [url]="'/hire/software-development'"
            [imgSrc]="'logged-out-navigation/hire-skills/sd.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [colTablet]="4"
        >
          <app-navigation-menu-card
            i18n-description="3D artists description"
            description="3D artists"
            [url]="'/hire/3d-design'"
            [imgSrc]="'logged-out-navigation/hire-skills/3d.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [colTablet]="4"
        >
          <app-navigation-menu-card
            i18n-description="Illustration description"
            description="Illustration"
            [url]="'/hire/illustration'"
            [imgSrc]="'logged-out-navigation/hire-skills/illustration.png'"
            [isLoggedOut]="true"
          >
          </app-navigation-menu-card>
        </fl-col>
      </fl-grid>
    </div>
    <div class="LinksColumn">
      <div class="ViewMoreContainer">
        <p
          class="text-light font-bold"
          i18n="Side Bar Title"
          [flMarginBottom]="'mid'"
        >
          Other popular skills
        </p>
        <fl-link
          flTrackingLabel="SkillViewMoreLink"
          i18n="View More link"
          class="ViewMoreColor"
          [flHideDesktopXLarge]="true"
          [newTab]="false"
          [iconName]="'ui-chevron-right'"
          [iconPosition]="LinkIconPosition.RIGHT"
          [color]="LinkColor.INHERIT"
          [iconColor]="IconColor.INHERIT"
          [weight]="LinkWeight.MEDIUM"
          (click)="handleSecondLayer()"
        >
          View more
        </fl-link>
      </div>
      <app-navigation-menu-list
        [list]="hirePopularSkills"
        [marginBottomTablet]="'xsmall'"
      >
      </app-navigation-menu-list>
      <app-navigation-menu-list
        [list]="hireFullSkillsList"
        class="SeoContent"
      >
      </app-navigation-menu-list>
      <fl-link
        flTrackingLabel="SkillViewMoreLink"
        i18n="View More link"
        class="ViewMoreColor"
        [flShowDesktopXLarge]="true"
        [link]="'/hire'"
        [newTab]="false"
        [iconName]="'ui-chevron-right'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [weight]="LinkWeight.MEDIUM"
        [color]="LinkColor.INHERIT"
        [iconColor]="IconColor.INHERIT"
        [iconAnimation]="true"
      >
        View more
      </fl-link>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-sections.component.scss'],
})
export class NavigationLoggedOutHomeSectionHireFreelancersBySkillsComponent {
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;

  hireFullSkillsList = [
    {
      linkDescription: $localize`Graphic Designers`,
      linkUrl: '/hire/graphic-design',
    },
    {
      linkDescription: $localize`Logo Designers`,
      linkUrl: '/hire/logo-design',
    },
    {
      linkDescription: $localize`3D Graphic Designers`,
      linkUrl: '/hire/3d-design',
    },
    {
      linkDescription: $localize`Web Designers`,
      linkUrl: '/hire/website-design',
    },
    {
      linkDescription: $localize`Web Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`Mobile App Developers`,
      linkUrl: '/hire/mobile-development',
    },
    {
      linkDescription: $localize`Writers`,
      linkUrl: '/hire/writing',
    },
    {
      linkDescription: $localize`Internet Marketing Specialists`,
      linkUrl: '/hire/internet-marketing',
    },
    {
      linkDescription: $localize`SEO Specialists`,
      linkUrl: '/hire/seo',
    },
    {
      linkDescription: $localize`Data Entry Clerks`,
      linkUrl: '/hire/data-entry',
    },
    {
      linkDescription: $localize`Virtual Assistants`,
      linkUrl: '/hire/virtual-assistant',
    },
    {
      linkDescription: $localize`Software Developers`,
      linkUrl: '/hire/software-development',
    },
    {
      linkDescription: $localize`Translators`,
      linkUrl: '/hire/translation',
    },
    {
      linkDescription: $localize`Financial Experts`,
      linkUrl: '/hire/finance',
    },
    {
      linkDescription: $localize`Lawyers`,
      linkUrl: '/hire/legal',
    },
    {
      linkDescription: $localize`Manufacturers`,
      linkUrl: '/hire/manufacturing',
    },
    {
      linkDescription: $localize`Logistics Experts`,
      linkUrl: '/hire/logistics-shipping',
    },
    {
      linkDescription: $localize`Photoshop Designers`,
      linkUrl: '/hire/photoshop',
    },
    {
      linkDescription: $localize`Illustrators`,
      linkUrl: '/hire/illustration',
    },
    {
      linkDescription: $localize`Motion Graphics Designers`,
      linkUrl: '/hire/motion-graphics',
    },
    {
      linkDescription: $localize`2D Animators`,
      linkUrl: '/hire/2d-animation',
    },
    {
      linkDescription: $localize`3D Animators`,
      linkUrl: '/hire/3d-animation',
    },
    {
      linkDescription: $localize`Business Card Designers`,
      linkUrl: '/hire/business-cards',
    },
    {
      linkDescription: $localize`Tattoo Designers`,
      linkUrl: '/hire/tattoo-design',
    },
    {
      linkDescription: $localize`Stationery Designers`,
      linkUrl: '/hire/stationery-design',
    },
    {
      linkDescription: $localize`Fashion Designers`,
      linkUrl: '/hire/fashion-design',
    },
    {
      linkDescription: $localize`Brochure Designers`,
      linkUrl: '/hire/brochure-design',
    },
    {
      linkDescription: $localize`T-Shirt Designers`,
      linkUrl: '/hire/tshirts',
    },
    {
      linkDescription: $localize`Other Graphic Designers`,
      linkUrl: '/hire/graphic-design',
    },
    {
      linkDescription: $localize`3D Modelers`,
      linkUrl: '/hire/3d-modelling',
    },
    {
      linkDescription: $localize`3D Renderers`,
      linkUrl: '/hire/rendering',
    },
    {
      linkDescription: $localize`Other 3D Graphic Designers`,
      linkUrl: '/hire/3d-design',
    },
    {
      linkDescription: $localize`Wordpress Web Designers`,
      linkUrl: '/hire/wordpress',
    },
    {
      linkDescription: $localize`Squarespace Web Designers`,
      linkUrl: '/hire/squarespace',
    },
    {
      linkDescription: $localize`Wix Web Designers`,
      linkUrl: '/hire/wix',
    },
    {
      linkDescription: $localize`Shopify Web Designers`,
      linkUrl: '/hire/shopify',
    },
    {
      linkDescription: $localize`Magento Web Designers`,
      linkUrl: '/hire/magento',
    },
    {
      linkDescription: $localize`PHP Web Developers`,
      linkUrl: '/hire/php',
    },
    {
      linkDescription: $localize`HTML5 Web Developers`,
      linkUrl: '/hire/html5',
    },
    {
      linkDescription: $localize`CSS Web Developers`,
      linkUrl: '/hire/css',
    },
    {
      linkDescription: $localize`Javascript Web Developers`,
      linkUrl: '/hire/javascript',
    },
    {
      linkDescription: $localize`Ruby on Rails Web Developers`,
      linkUrl: '/hire/ruby-on-rails',
    },
    {
      linkDescription: $localize`node.js Web Developers`,
      linkUrl: '/hire/nodejs',
    },
    {
      linkDescription: $localize`Angular.js Web Developers`,
      linkUrl: '/hire/angular-js',
    },
    {
      linkDescription: $localize`React.js Web Developers`,
      linkUrl: '/hire/react-js',
    },
    {
      linkDescription: $localize`Other Web Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`iPhone Mobile App Developers`,
      linkUrl: '/hire/ios-development',
    },
    {
      linkDescription: $localize`Android Mobile App Developers`,
      linkUrl: '/hire/android',
    },
    {
      linkDescription: $localize`PhoneGap Mobile App Developers`,
      linkUrl: '/hire/phonegap',
    },
    {
      linkDescription: $localize`Flutter Mobile App Developers`,
      linkUrl: '/hire/flutter',
    },
    {
      linkDescription: $localize`Xamarin Mobile App Developers`,
      linkUrl: '/hire/xamarin',
    },
    {
      linkDescription: $localize`Other Mobile App Developers`,
      linkUrl: '/hire/mobile-development',
    },
    {
      linkDescription: $localize`Article Writers`,
      linkUrl: '/hire/articles',
    },
    {
      linkDescription: $localize`Copywriters`,
      linkUrl: '/hire/copywriting',
    },
    {
      linkDescription: $localize`Ghostwriters`,
      linkUrl: '/hire/ghostwriting',
    },
    {
      linkDescription: $localize`Other Writers`,
      linkUrl: '/hire/writing',
    },
    {
      linkDescription: $localize`Social Media Marketing Specialists`,
      linkUrl: '/hire/social-media-marketing',
    },
    {
      linkDescription: $localize`Other Internet Marketing Specialists`,
      linkUrl: '/hire/internet-marketing',
    },
    {
      linkDescription: $localize`Java Software Developers`,
      linkUrl: '/hire/java',
    },
    {
      linkDescription: $localize`C++ Software Developers`,
      linkUrl: '/cplusplus-programming',
    },
    {
      linkDescription: $localize`Python Software Developers`,
      linkUrl: '/hire/python',
    },
    {
      linkDescription: $localize`Database Software Developers`,
      linkUrl: '/hire/database-programming',
    },
    {
      linkDescription: $localize`Linux Software Developers`,
      linkUrl: '/hire/linux',
    },
    {
      linkDescription: $localize`Objective C Software Developers`,
      linkUrl: '/hire/software-development',
    },
    {
      linkDescription: $localize`Other Software Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`Spanish Translators`,
      linkUrl: '/hire/spanish',
    },
    {
      linkDescription: $localize`English Translators`,
      linkUrl: '/hire/english-uk-translator',
    },
    {
      linkDescription: $localize`Portuguese Translators`,
      linkUrl: '/hire/portuguese',
    },
    {
      linkDescription: $localize`French Translators`,
      linkUrl: '/hire/french-translator',
    },
    {
      linkDescription: $localize`German Translators`,
      linkUrl: '/hire/german',
    },
    {
      linkDescription: $localize`Other Translators`,
      linkUrl: '/hire/translation',
    },
  ];

  hirePopularSkills = [
    {
      linkDescription: $localize`Web developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`Writers`,
      linkUrl: '/hire/writing',
    },
    {
      linkDescription: $localize`Marketing specialists`,
      linkUrl: '/hire/internet-marketing',
    },
    {
      linkDescription: $localize`SEO specialists`,
      linkUrl: '/hire/seo',
    },
    {
      linkDescription: $localize`Data entry clerks`,
      linkUrl: '/hire/data-entry',
    },
    {
      linkDescription: $localize`Virtual assistants`,
      linkUrl: '/hire/virtual-assistant',
    },
    {
      linkDescription: $localize`Translators`,
      linkUrl: '/hire/translation',
    },
    {
      linkDescription: $localize`Financial experts`,
      linkUrl: '/hire/finance',
    },
    {
      linkDescription: $localize`Manufacturers`,
      linkUrl: '/hire/manufacturing',
    },
    {
      linkDescription: $localize`Logistics experts`,
      linkUrl: '/hire/logistics-shipping',
    },
    {
      linkDescription: $localize`Fashion designers`,
      linkUrl: '/hire/fashion-design',
    },
  ];

  @Output() viewSecondLayer = new EventEmitter<void>();

  handleSecondLayer(): void {
    this.viewSecondLayer.emit();
  }
}

@Component({
  selector:
    'app-navigation-logged-out-home-section-hire-freelancers-by-skills-list',
  template: `
    <app-navigation-menu-list [list]="hireFullSkillsList">
    </app-navigation-menu-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionHireFreelancersBySkillsListComponent {
  hireFullSkillsList = [
    {
      linkDescription: $localize`Graphic Designers`,
      linkUrl: '/hire/graphic-design',
    },
    {
      linkDescription: $localize`Logo Designers`,
      linkUrl: '/hire/logo-design',
    },
    {
      linkDescription: $localize`3D Graphic Designers`,
      linkUrl: '/hire/3d-design',
    },
    {
      linkDescription: $localize`Web Designers`,
      linkUrl: '/hire/website-design',
    },
    {
      linkDescription: $localize`Web Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`Mobile App Developers`,
      linkUrl: '/hire/mobile-development',
    },
    {
      linkDescription: $localize`Writers`,
      linkUrl: '/hire/writing',
    },
    {
      linkDescription: $localize`Internet Marketing Specialists`,
      linkUrl: '/hire/internet-marketing',
    },
    {
      linkDescription: $localize`SEO Specialists`,
      linkUrl: '/hire/seo',
    },
    {
      linkDescription: $localize`Data Entry Clerks`,
      linkUrl: '/hire/data-entry',
    },
    {
      linkDescription: $localize`Virtual Assistants`,
      linkUrl: '/hire/virtual-assistant',
    },
    {
      linkDescription: $localize`Software Developers`,
      linkUrl: '/hire/software-development',
    },
    {
      linkDescription: $localize`Translators`,
      linkUrl: '/hire/translation',
    },
    {
      linkDescription: $localize`Financial Experts`,
      linkUrl: '/hire/finance',
    },
    {
      linkDescription: $localize`Lawyers`,
      linkUrl: '/hire/legal',
    },
    {
      linkDescription: $localize`Manufacturers`,
      linkUrl: '/hire/manufacturing',
    },
    {
      linkDescription: $localize`Logistics Experts`,
      linkUrl: '/hire/logistics-shipping',
    },
    {
      linkDescription: $localize`Photoshop Designers`,
      linkUrl: '/hire/photoshop',
    },
    {
      linkDescription: $localize`Illustrators`,
      linkUrl: '/hire/illustration',
    },
    {
      linkDescription: $localize`Motion Graphics Designers`,
      linkUrl: '/hire/motion-graphics',
    },
    {
      linkDescription: $localize`2D Animators`,
      linkUrl: '/hire/2d-animation',
    },
    {
      linkDescription: $localize`3D Animators`,
      linkUrl: '/hire/3d-animation',
    },
    {
      linkDescription: $localize`Business Card Designers`,
      linkUrl: '/hire/business-cards',
    },
    {
      linkDescription: $localize`Tattoo Designers`,
      linkUrl: '/hire/tattoo-design',
    },
    {
      linkDescription: $localize`Stationery Designers`,
      linkUrl: '/hire/stationery-design',
    },
    {
      linkDescription: $localize`Fashion Designers`,
      linkUrl: '/hire/fashion-design',
    },
    {
      linkDescription: $localize`Brochure Designers`,
      linkUrl: '/hire/brochure-design',
    },
    {
      linkDescription: $localize`T-Shirt Designers`,
      linkUrl: '/hire/tshirts',
    },
    {
      linkDescription: $localize`Other Graphic Designers`,
      linkUrl: '/hire/graphic-design',
    },
    {
      linkDescription: $localize`3D Modelers`,
      linkUrl: '/hire/3d-modelling',
    },
    {
      linkDescription: $localize`3D Renderers`,
      linkUrl: '/hire/rendering',
    },
    {
      linkDescription: $localize`Other 3D Graphic Designers`,
      linkUrl: '/hire/3d-design',
    },
    {
      linkDescription: $localize`Wordpress Web Designers`,
      linkUrl: '/hire/wordpress',
    },
    {
      linkDescription: $localize`Squarespace Web Designers`,
      linkUrl: '/hire/squarespace',
    },
    {
      linkDescription: $localize`Wix Web Designers`,
      linkUrl: '/hire/wix',
    },
    {
      linkDescription: $localize`Shopify Web Designers`,
      linkUrl: '/hire/shopify',
    },
    {
      linkDescription: $localize`Magento Web Designers`,
      linkUrl: '/hire/magento',
    },
    {
      linkDescription: $localize`PHP Web Developers`,
      linkUrl: '/hire/php',
    },
    {
      linkDescription: $localize`HTML5 Web Developers`,
      linkUrl: '/hire/html5',
    },
    {
      linkDescription: $localize`CSS Web Developers`,
      linkUrl: '/hire/css',
    },
    {
      linkDescription: $localize`Javascript Web Developers`,
      linkUrl: '/hire/javascript',
    },
    {
      linkDescription: $localize`Ruby on Rails Web Developers`,
      linkUrl: '/hire/ruby-on-rails',
    },
    {
      linkDescription: $localize`node.js Web Developers`,
      linkUrl: '/hire/nodejs',
    },
    {
      linkDescription: $localize`Angular.js Web Developers`,
      linkUrl: '/hire/angular-js',
    },
    {
      linkDescription: $localize`React.js Web Developers`,
      linkUrl: '/hire/react-js',
    },
    {
      linkDescription: $localize`Other Web Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`iPhone Mobile App Developers`,
      linkUrl: '/hire/ios-development',
    },
    {
      linkDescription: $localize`Android Mobile App Developers`,
      linkUrl: '/hire/android',
    },
    {
      linkDescription: $localize`PhoneGap Mobile App Developers`,
      linkUrl: '/hire/phonegap',
    },
    {
      linkDescription: $localize`Flutter Mobile App Developers`,
      linkUrl: '/hire/flutter',
    },
    {
      linkDescription: $localize`Xamarin Mobile App Developers`,
      linkUrl: '/hire/xamarin',
    },
    {
      linkDescription: $localize`Other Mobile App Developers`,
      linkUrl: '/hire/mobile-development',
    },
    {
      linkDescription: $localize`Article Writers`,
      linkUrl: '/hire/articles',
    },
    {
      linkDescription: $localize`Copywriters`,
      linkUrl: '/hire/copywriting',
    },
    {
      linkDescription: $localize`Ghostwriters`,
      linkUrl: '/hire/ghostwriting',
    },
    {
      linkDescription: $localize`Other Writers`,
      linkUrl: '/hire/writing',
    },
    {
      linkDescription: $localize`Social Media Marketing Specialists`,
      linkUrl: '/hire/social-media-marketing',
    },
    {
      linkDescription: $localize`Other Internet Marketing Specialists`,
      linkUrl: '/hire/internet-marketing',
    },
    {
      linkDescription: $localize`Java Software Developers`,
      linkUrl: '/hire/java',
    },
    {
      linkDescription: $localize`C++ Software Developers`,
      linkUrl: '/cplusplus-programming',
    },
    {
      linkDescription: $localize`Python Software Developers`,
      linkUrl: '/hire/python',
    },
    {
      linkDescription: $localize`Database Software Developers`,
      linkUrl: '/hire/database-programming',
    },
    {
      linkDescription: $localize`Linux Software Developers`,
      linkUrl: '/hire/linux',
    },
    {
      linkDescription: $localize`Objective C Software Developers`,
      linkUrl: '/hire/software-development',
    },
    {
      linkDescription: $localize`Other Software Developers`,
      linkUrl: '/hire/web-development',
    },
    {
      linkDescription: $localize`Spanish Translators`,
      linkUrl: '/hire/spanish',
    },
    {
      linkDescription: $localize`English Translators`,
      linkUrl: '/hire/english-uk-translator',
    },
    {
      linkDescription: $localize`Portuguese Translators`,
      linkUrl: '/hire/portuguese',
    },
    {
      linkDescription: $localize`French Translators`,
      linkUrl: '/hire/french-translator',
    },
    {
      linkDescription: $localize`German Translators`,
      linkUrl: '/hire/german',
    },
    {
      linkDescription: $localize`Other Translators`,
      linkUrl: '/hire/translation',
    },
  ];
}

@Component({
  selector:
    'app-navigation-logged-out-home-section-hire-freelancers-by-location',
  template: `
    <div
      class="LinksColumn"
      [flMarginRightDesktopXLarge]="'large'"
      [flMarginBottom]="'mid'"
      [flMarginBottomDesktopXLarge]="'none'"
    >
      <div class="ViewMoreContainer">
        <p
          class="text-light font-bold"
          i18n="Side Bar Title"
          [flMarginBottom]="'mid'"
          [flMarginRightDesktop]="'xxsmall'"
        >
          Choose from millions of freelancers worldwide.
        </p>
      </div>
      <app-navigation-menu-list
        [list]="hireLocationList"
        [marginBottomTablet]="'xxsmall'"
      >
      </app-navigation-menu-list>
      <fl-link
        flTrackingLabel="LocationViewMoreLink"
        i18n="View more link"
        class="ViewMoreColor"
        [flMarginBottom]="'mid'"
        [flMarginBottomDesktopLarge]="'none'"
        [link]="'/freelancers'"
        [newTab]="false"
        [iconName]="'ui-chevron-right'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [iconColor]="IconColor.INHERIT"
        [weight]="LinkWeight.MEDIUM"
        [iconAnimation]="true"
      >
        View more
      </fl-link>
    </div>
    <div>
      <fl-grid class="TwoColumns">
        <fl-col
          [col]="6"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'mid'"
        >
          <app-navigation-menu-card
            i18n-description="description"
            description="Working with international freelancers"
            [url]="'/freelancers'"
            [imgSrc]="'logged-out-navigation/hire-location/location-1.jpg'"
            [isLoggedOut]="true"
            [readMore]="true"
            [longDescription]="true"
            [descriptionWeight]="FontWeight.NORMAL"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col
          [col]="6"
          [flMarginBottom]="'small'"
          [flMarginBottomDesktop]="'mid'"
        >
          <app-navigation-menu-card
            i18n-description="description"
            description="Where to find the best developers"
            [url]="'/hire/software-development'"
            [imgSrc]="'logged-out-navigation/hire-location/location-2.jpg'"
            [isLoggedOut]="true"
            [readMore]="true"
            [longDescription]="true"
            [descriptionWeight]="FontWeight.NORMAL"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col [col]="6">
          <app-navigation-menu-card
            i18n-description="description"
            description="Do you need a local freelancer?"
            [url]="'/local'"
            [imgSrc]="'logged-out-navigation/hire-location/location-3.jpg'"
            [isLoggedOut]="true"
            [readMore]="true"
            [longDescription]="true"
            [descriptionWeight]="FontWeight.NORMAL"
          >
          </app-navigation-menu-card>
        </fl-col>
        <fl-col [col]="6">
          <app-navigation-menu-card
            i18n-description="description"
            description="Building an international team"
            [url]="'/freelancers'"
            [imgSrc]="'logged-out-navigation/hire-location/location-4.jpg'"
            [isLoggedOut]="true"
            [readMore]="true"
            [longDescription]="true"
            [descriptionWeight]="FontWeight.NORMAL"
          >
          </app-navigation-menu-card>
        </fl-col>
      </fl-grid>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-sections.component.scss'],
})
export class NavigationLoggedOutHomeSectionHireFreelancersByLocationComponent {
  FontWeight = FontWeight;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  IconColor = IconColor;

  hireLocationList = [
    {
      linkDescription: $localize`United States`,
      linkUrl: '/freelancers/united-states',
    },
    {
      linkDescription: $localize`United Kingdom`,
      linkUrl: '/freelancers/united-kingdom',
    },
    {
      linkDescription: $localize`Canada`,
      linkUrl: '/freelancers/canada',
    },
    {
      linkDescription: $localize`India`,
      linkUrl: '/freelancers/india',
    },
    {
      linkDescription: $localize`Australia`,
      linkUrl: '/freelancers/australia',
    },
    {
      linkDescription: $localize`Pakistan`,
      linkUrl: '/freelancers/pakistan',
    },
    {
      linkDescription: $localize`Bangladesh`,
      linkUrl: '/freelancers/bangladesh',
    },
    {
      linkDescription: $localize`Indonesia`,
      linkUrl: '/freelancers/indonesia',
    },
    {
      linkDescription: $localize`Brazil`,
      linkUrl: '/freelancers/brazil',
    },
    {
      linkDescription: $localize`China`,
      linkUrl: '/freelancers/china',
    },
    {
      linkDescription: $localize`Turkey`,
      linkUrl: '/freelancers/turkey',
    },
    {
      linkDescription: $localize`Philippines`,
      linkUrl: '/freelancers/philippines',
    },
  ];

  @Output() viewSecondLayer = new EventEmitter<void>();

  handleSecondLayer(): void {
    this.viewSecondLayer.emit();
  }
}

@Component({
  selector: 'app-navigation-logged-out-home-section-hire-freelancers',
  template: `
    <fl-callout
      class="Callout"
      [edgeToEdge]="true"
      [placement]="CalloutPlacement.BOTTOM"
      [hideCloseButton]="true"
      [hover]="true"
      [hideArrow]="true"
      [crawlable]="true"
      [color]="CalloutColor.DARK"
      (calloutOpen)="openCalloutHandler()"
      (calloutClose)="closeCalloutHandler()"
    >
      <fl-callout-trigger class="Callout">
        <fl-link
          class="NavigationItem"
          flTrackingLabel="Hirefreelancers"
          i18n="Navigation hire freelancers label"
          [flHideMobile]="true"
          [flHideTablet]="true"
          [class.IsCalloutOpen]="isCalloutOpen"
          [iconName]="'ui-chevron-down'"
          [iconColor]="IconColor.INHERIT"
          [iconPosition]="LinkIconPosition.RIGHT"
          [size]="TextSize.SMALL"
          [flMarginRight]="'small'"
          [color]="LinkColor.LIGHT"
          [underline]="LinkUnderline.NEVER"
        >
          Hire freelancers
        </fl-link>
      </fl-callout-trigger>
      <fl-callout-content>
        <div class="CalloutContent">
          <div class="NavContainer">
            <app-navigation-menu-nav-item
              i18n-titleLink="By skill navigation item title text"
              titleLink="By skill"
              i18n-description="By skill navigation item description text"
              description="
                Looking for a freelancer with a specific skill? Start here.
              "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [contentId]="'skill'"
              [iconName]="'ui-person-brain'"
              [iconArrowColor]="IconColor.LIGHT"
              [isActive]="selectedTab === 'skill'"
              (hover)="selectTab($event)"
            ></app-navigation-menu-nav-item>
            <app-navigation-menu-nav-item
              i18n-titleLink="By location navigation item title text"
              titleLink="By location"
              i18n-description="By location navigation item description text"
              description="
                Search for freelancers based on their location and timezone.
              "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [flMarginBottom]="'xxxsmall'"
              [contentId]="'location'"
              [iconName]="'ui-person-pin'"
              [iconArrowColor]="IconColor.LIGHT"
              [isActive]="selectedTab === 'location'"
              (hover)="selectTab($event)"
            ></app-navigation-menu-nav-item>
            <app-navigation-menu-nav-item
              i18n-titleLink="By category navigation item title text"
              titleLink="By category"
              i18n-description="By category navigation item description text"
              description="
                Find freelancers that suit a certain project category.
              "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [iconName]="'ui-category'"
              [iconArrow]="false"
              [url]="'/hire'"
            ></app-navigation-menu-nav-item>
          </div>
          <div class="SidePanel">
            <div
              id="skill"
              class="GridContainer"
              [class.IsActive]="selectedTab === 'skill'"
            >
              <app-navigation-logged-out-home-section-hire-freelancers-by-skills />
            </div>
            <div
              id="location"
              class="GridContainer"
              [class.IsActive]="selectedTab === 'location'"
            >
              <app-navigation-logged-out-home-section-hire-freelancers-by-location />
            </div>
          </div>
        </div>
      </fl-callout-content>
    </fl-callout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-callouts.component.scss'],
  animations: [slideInHorizontalAnimation],
})
export class NavigationLoggedOutHomeSectionHireFreelancersComponent {
  CalloutPlacement = CalloutPlacement;
  CalloutColor = CalloutColor;
  IconColor = IconColor;
  FontColor = FontColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkUnderline = LinkUnderline;
  TextSize = TextSize;

  isCalloutOpen = false;
  defaultTab = 'skill';
  selectedTab?: string | undefined = this.defaultTab;

  selectTab(tab: string | undefined): void {
    this.selectedTab = tab;
  }

  openCalloutHandler(): void {
    this.isCalloutOpen = true;
  }

  closeCalloutHandler(): void {
    this.isCalloutOpen = false;
    this.selectedTab = this.defaultTab;
  }
}
